module.exports = __webpack_public_path__ + "static/eye_and_hand_of_vecna-605c8173e3242f0352e1ce77f8a9aef3.jpeg";